import { tryMsAuthSilent } from 'services/auth/ms.service';
import apiClient from './apiClient';

// A base query function for RTK Query using axios apiClient instance
export const axiosBaseQuery = ({ baseUrl = '' } = {}) => {
  return async ({ url = '', method = 'GET', data, params, headers, responseType, msAuth }) => {
    try {
      const requestHeaders = { ...(headers || {}) };

      if (msAuth?.instance && Array.isArray(msAuth?.scopes) && msAuth.scopes.length > 0) {
        const msRes = await tryMsAuthSilent(msAuth.instance, msAuth.scopes);
        if (msRes?.accessToken) {
          requestHeaders.MsAuth = `Bearer ${msRes.accessToken}`;
        }
      }

      const response = await apiClient({
        url: baseUrl + url, // This is the api endpoint URL
        method, // HTTP method: GET, POST, etc.
        data, // Request body for POST, PUT, etc.
        params, // Query string parameters for GET requests
        headers: requestHeaders, // Custom headers if any
        responseType, // Response type if needed (e.g., 'blob' for file downloads)
      });

      return { data: response.data };
    } catch (error) {
      return {
        error: {
          status: error.response?.status ?? 'FETCH_ERROR',
          message: error.response?.data?.message ?? error.message ?? 'An error occurred.',
          raw: error.response?.data ?? null,
        },
      };
    }
  };
};
